import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const CategoryFix = () => {
  
  const devMode = process.env.NODE_ENV === 'development';
  
  const { categoryId } = useParams();
  const [slideoutFlag, setSlideoutFlag] = useState(false);
  const [categoryName, _setCategoryName] = useState('');
  const [categoryColor, setCategoryColor] = useState(0);
  const [headeruntop, setHeaderuntop] = useState(false);
  const setCategoryName = e => {_setCategoryName(e.target.value)};

  const navigate = useNavigate();

  const getCategoryData = () => {
    if (devMode) {
      fetch(`http://${window.location.hostname}:8080/mempad/cat/get`, {method: 'post', body: JSON.stringify({id: categoryId})}).then(r=>r.json()).then(data=>{
        _setCategoryName(data.name);
        setCategoryColor(Number(data.color));
      });
    } else {
      const fd = new FormData();
      fd.append('id', categoryId);
      fetch('/mempad/cat/get', {method: 'post', body: fd}).then(r=>r.json()).then(data=>{
        _setCategoryName(data.name);
        setCategoryColor(Number(data.color));
      });
    }
  }

  useEffect(() => {
    getCategoryData();
  }, []);

  const backFunc = () => {
    setSlideoutFlag(true);
    setTimeout(() => navigate(-1), 250);
  }

  const changeHeaderStyle = e => {
    if (e.target.scrollTop <= 0 && headeruntop) setHeaderuntop(false);
    else if (e.target.scrollTop > 0 && !headeruntop) setHeaderuntop(true);
  }

  const fixCategory = () => {
    if (categoryName.length > 0) {
      if (devMode) {
        fetch(`http://${window.location.hostname}:8080/mempad/cat/fix`, {method: 'post', body: JSON.stringify({id: categoryId, name: categoryName, color: categoryColor})}).then(() => {
          backFunc();
        });
      } else {
        const fd = new FormData();
        fd.append('id', categoryId);
        fd.append('name', categoryName);
        fd.append('color', categoryColor);
        fetch('/mempad/cat/fix', {method: 'post', body: fd}).then(() => {
          backFunc();
        });
      }
    }
  }

  const delCategory = () => {
    if (window.confirm('本当にこのカテゴリを削除しますか？\n※カテゴリ内のメモも削除されます')) {
      if (devMode) {
        fetch(`http://${window.location.hostname}:8080/mempad/cat/del`, {method: 'post', body: JSON.stringify({id: categoryId})}).then(() => {
          backFunc();
        });
      } else {
        const fd = new FormData();
        fd.append('id', categoryId);
        fetch('/mempad/cat/del', {method: 'post', body: fd}).then(() => {
          backFunc();
        });
      }
    }
  }

  return (
    <div id="memo-layout" className={slideoutFlag ? "layout layout-over-slideout" : "layout layout-over"}>
      <header className={headeruntop ? 'header-untop' : ''}>
        <a className="header-left" onClick={backFunc}>＜戻る</a>
        <h3 className="header-title">カテゴリの編集</h3>
        <a className={categoryName.length === 0 ? 'header-right unactivelink' : 'header-right'} onClick={fixCategory}>編集</a>
      </header>
      <div className="top-scroller" onClick={e => e.target.parentElement.getElementsByTagName('main')[0].scrollTo({top:0, left:0, behavior: 'smooth'})} />
      <main onScroll={changeHeaderStyle}>
        <div className="content-box">
          <input id="category-name-input" className="line-input" type="text" value={categoryName} onChange={setCategoryName} placeholder="カテゴリ名" />
          <hr />
          {[...Array(13)].map((_, key) => 
            <span key={key}>
              <input hidden id={`colordata-${key}`} type="radio" name="colordata" value={key} checked={key === categoryColor} onChange={() => setCategoryColor(key)}/>
              <label className={`category-color bg-col${key}`} htmlFor={`colordata-${key}`} />
            </span>
          )}
        </div>
        <a className="listbox alertbox" onClick={delCategory}>カテゴリを削除</a>
      </main>
    </div>
  );
}

export default CategoryFix;